import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import HeaderBar from 'Views/Onboarding/Components/HeaderBar';

const styles = () => ({
  root: {},
});

const SurveyContentHeader = ({
  className,
  classes,
  ...rest
}) => {
  return (
    <HeaderBar
      className={classNames(classes.root, className)}
      {...rest}
    />
  );
};

SurveyContentHeader.defaultProps = {
  className: '',
};

SurveyContentHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SurveyContentHeader);
